import React, { Component } from 'react';
import { Row, Col, Avatar, Descriptions } from 'antd';
import _ from 'lodash';
import Button from "../../../components/uielements/button";
import axios from "axios";
import Config from "../../../settings/urbanice-api";
import { siteConfig } from "../../../settings";
import { notification } from '../../../components/index';
import { Link } from "react-router-dom";
import UserProfileWrapper from './userProfile.style';

const DEBUG = siteConfig.DEBUG
const GET_USER_INFO = Config.GET_USER_INFO;

var moment = require("moment");
require('moment/locale/th.js');

class userInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userToken: "",
            communityID: "",
            userID: "",
            userInfo: '',
            loadingBT: false,
        };

        this.state.userToken = localStorage.getItem('access_token');
        DEBUG && console.log('UserToken: ' + this.state.userToken);


        this.state.communityID = localStorage.getItem('communityID');
        DEBUG && console.log('communityID: ' + this.state.communityID);
    }

    /***** COMPONENT DID MOUNT FUNCTIONs *****/
    componentDidMount() {
        DEBUG && console.log("componentDidMount");

        this.getUserInfoV2();
    }

    /***** GET USER INFO FUNCTION - V2 *****/
    getUserInfoV2() {
        let axiosConfig = {
            headers: {
                'Authorization': 'Bearer ' + this.state.userToken
            }
        };

        axios
            .get(GET_USER_INFO, axiosConfig)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    if (response.data.isSuccess) {
                        //STORE TO LOCALSTORAGE
                        localStorage.setItem('userID', response.data.profile.email);
                        localStorage.setItem('userFirstname', response.data.profile.firstname)
                        localStorage.setItem('userLastname', response.data.profile.lastname)
                        localStorage.setItem('userImageUrl', response.data.profile.imageUrl);
                        this.setState({
                            userID: response.data.userID,
                            userInfo: response.data,
                        }, () => {
                            DEBUG && console.log('userInfo:', this.state.userInfo)
                            DEBUG && console.log('userInfo:', JSON.stringify(this.state.userInfo))
                        });
                    }
                    else {
                        DEBUG && console.log("Error", "ดาวน์โหลดข้อมูลไม่สำเร็จ: " + response.data.errorMessage);
                        this.setState({
                            isLoading: false,
                        }, () => {
                            DEBUG && console.log(`isLoading:false`);
                            notification('error', "ดาวน์โหลดข้อมูลไม่สำเร็จ: " + response.data.errorMessage);
                        });
                    }
                }


            })
            .catch(err => {
                DEBUG && console.log("err", err);
                notification('error', `${err.toString()}`);
            });

    }


    /***** RENDER FUNCTIONs *****/
    render() {
        const { userInfo } = this.state

        return (
            <UserProfileWrapper>
                <div >
                    <div className="ButtonRightFixed">
                        <Link
                            to={{
                                pathname: `/dashboard/profile/edit`,
                                state: {
                                    userInfo: userInfo
                                }
                            }}
                        >
                            <Button
                                icon="edit"
                                type="primary"
                            // onClick={this.showModalCreateNewBiz}
                            >
                                <span className="TextBtnH3">แก้ไขข้อมูลผู้ใช้</span>
                            </Button>
                        </Link>
                    </div>

                    <Row type="flex" justify='start' gutter="16" style={{ marginBottom: 10 }}>
                        <Col xs={6} sm={6} md={4} lg={4} xl={2}> รูปโปรไฟล์ </Col>
                        <Col xs={18} sm={18} md={20} lg={20} xl={8}>
                            <Avatar
                                src={userInfo && userInfo.profile.imageUrl}
                                shape="circle"
                                size={96}
                            />
                        </Col>
                    </Row>
                    <Row type="flex" justify='start' gutter="16" style={{ marginBottom: 10 }}>
                        <Col xs={6} sm={6} md={4} lg={4} xl={2}> ชื่อ </Col>
                        <Col xs={18} sm={18} md={20} lg={20} xl={8}>
                            {userInfo && userInfo.profile.firstname}{" "}{userInfo && userInfo.profile.lastname}
                        </Col>
                    </Row>
                    <Row type="flex" justify='start' gutter="16" style={{ marginBottom: 10 }}>
                        <Col xs={6} sm={6} md={4} lg={4} xl={2}>  อีเมล </Col>
                        <Col xs={18} sm={18} md={20} lg={20} xl={8}>
                            {_.isNil(userInfo && userInfo.profile.email) ? '' : userInfo && userInfo.profile.email}
                        </Col>
                    </Row>
                    <Row type="flex" justify='start' gutter="16" style={{ marginBottom: 10 }}>
                        <Col xs={6} sm={6} md={4} lg={4} xl={2}>  เพศ </Col>
                        <Col xs={18} sm={18} md={20} lg={20} xl={8}>
                            {_.isNil(userInfo && userInfo.profile.mobile) ? '' :
                                (userInfo && userInfo.profile.gender === 'MALE' ? 'ชาย' : (
                                    userInfo && userInfo.profile.gender === 'FEMALE' ? 'หญิง' : (
                                        userInfo && userInfo.profile.gender === 'OTHERS' ? 'LGBTQ' : 'ไม่ระบุ'
                                    )
                                )
                                )
                            }
                        </Col>
                    </Row>
                    <Row type="flex" justify='start' gutter="16" style={{ marginBottom: 10 }}>
                        <Col xs={6} sm={6} md={4} lg={4} xl={2}>  เบอร์มือถือ </Col>
                        <Col xs={18} sm={18} md={20} lg={20} xl={8}>
                            {_.isNil(userInfo && userInfo.profile.mobile) ? '' : userInfo && userInfo.profile.mobile}
                        </Col>
                    </Row>
                    <Row type="flex" justify='start' gutter="16" style={{ marginBottom: 10 }}>
                        <Col xs={6} sm={6} md={4} lg={4} xl={2}>  วันเกิด </Col>
                        <Col xs={18} sm={18} md={20} lg={20} xl={8}>
                            {_.isNil(userInfo && userInfo.profile.birthdate) ? '' : moment(userInfo && userInfo.profile.birthdate).format('ll')}
                        </Col>
                    </Row>


                </div>
            </UserProfileWrapper>
        );
    }
}

export default userInfo;